import React from "react";

const primaryColor = "#4C4C4D";
const secondaryColor = "#E0E0E0";

function getColor(mode: string) {
  return mode === "dark" ? secondaryColor : primaryColor;
}
const DownArrow = function (
  mode:string,
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
): React.JSX.Element {

  if(!mode){
    mode = "light";
  }

  return (
    <div
      onClick={onClick}
      style={{
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8527 1.1003C10.9084 1.04767 10.9739 1.00653 11.0455 0.97922C11.1171 0.951911 11.1933 0.93897 11.2699 0.941137C11.3465 0.943304 11.4219 0.960535 11.4919 0.991848C11.5618 1.02316 11.6249 1.06794 11.6775 1.12363C11.7301 1.17932 11.7713 1.24484 11.7986 1.31643C11.8259 1.38802 11.8388 1.46429 11.8367 1.54088C11.8345 1.61747 11.8173 1.69289 11.786 1.76282C11.7547 1.83276 11.7099 1.89584 11.6542 1.94847L6.40419 6.9068C6.29588 7.0092 6.15248 7.06625 6.00344 7.06625C5.85439 7.06625 5.71099 7.0092 5.60269 6.9068L0.352102 1.94847C0.295192 1.89619 0.249235 1.83312 0.216905 1.76293C0.184573 1.69274 0.166512 1.61682 0.163768 1.53959C0.161024 1.46236 0.173654 1.38536 0.200922 1.31305C0.228189 1.24074 0.269553 1.17457 0.32261 1.11838C0.375667 1.0622 0.43936 1.01711 0.509988 0.985749C0.580616 0.954385 0.656772 0.937368 0.734033 0.935685C0.811293 0.934003 0.888118 0.947688 0.960045 0.975947C1.03197 1.00421 1.09757 1.04648 1.15302 1.1003L6.00344 5.68063L10.8527 1.1003Z"
          fill={getColor(mode)}
        />
      </svg>
    </div>
  );
};

const UpArrow = function (
  mode:string,
  onClick: (event: React.MouseEvent<HTMLDivElement| SVGElement>) => void
): React.JSX.Element {
  if(!mode){
    mode = "light";
  }
  return (
    <div
      onClick={onClick}
      style={{
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {" "}
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.14731 6.9006C1.09162 6.95323 1.02611 6.99437 0.95452 7.02168C0.882928 7.04899 0.806658 7.06193 0.730065 7.05976C0.653473 7.0576 0.578056 7.04036 0.508123 7.00905C0.43819 6.97774 0.375108 6.93296 0.322481 6.87727C0.269854 6.82158 0.228711 6.75606 0.201402 6.68447C0.174093 6.61288 0.161153 6.53661 0.163319 6.46002C0.165486 6.38343 0.182718 6.30801 0.21403 6.23808C0.245343 6.16814 0.290123 6.10506 0.345815 6.05243L5.59581 1.0941C5.70412 0.991705 5.84752 0.93465 5.99656 0.93465C6.14561 0.93465 6.28901 0.991705 6.39731 1.0941L11.6479 6.05243C11.7048 6.10471 11.7508 6.16778 11.7831 6.23797C11.8154 6.30816 11.8335 6.38408 11.8362 6.46131C11.839 6.53854 11.8263 6.61554 11.7991 6.68785C11.7718 6.76016 11.7304 6.82633 11.6774 6.88252C11.6243 6.9387 11.5606 6.98379 11.49 7.01515C11.4194 7.04652 11.3432 7.06353 11.266 7.06522C11.1887 7.0669 11.1119 7.05321 11.04 7.02495C10.968 6.99669 10.9024 6.95443 10.847 6.9006L5.99656 2.32027L1.14731 6.9006Z"
          fill={getColor(mode)}
        />
      </svg>
    </div>
  );
};

const RightArrow = function (
  mode:string,
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
): React.JSX.Element {
  
  if(!mode){
    mode = "light";
  }
  
  return (
    <div
      onClick={onClick}
      style={{
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.09932 1.14829C1.0467 1.0926 1.00555 1.02709 0.978244 0.955496C0.950935 0.883904 0.937994 0.807635 0.94016 0.731042C0.942327 0.654449 0.959559 0.579033 0.990871 0.5091C1.02218 0.439166 1.06696 0.376085 1.12266 0.323458C1.17835 0.270831 1.24386 0.229688 1.31545 0.202379C1.38704 0.17507 1.46331 0.162129 1.53991 0.164296C1.6165 0.166463 1.69191 0.183694 1.76185 0.215007C1.83178 0.246319 1.89486 0.2911 1.94749 0.346791L6.90582 5.59679C7.00822 5.7051 7.06527 5.84849 7.06527 5.99754C7.06527 6.14659 7.00822 6.28998 6.90582 6.39829L1.94749 11.6489C1.89521 11.7058 1.83214 11.7517 1.76195 11.7841C1.69176 11.8164 1.61585 11.8345 1.53862 11.8372C1.46139 11.84 1.38438 11.8273 1.31207 11.8001C1.23976 11.7728 1.17359 11.7314 1.11741 11.6784C1.06122 11.6253 1.01614 11.5616 0.984772 11.491C0.953408 11.4204 0.936391 11.3442 0.934709 11.2669C0.933026 11.1897 0.946711 11.1129 0.97497 11.0409C1.00323 10.969 1.0455 10.9034 1.09932 10.848L5.67966 5.99754L1.09932 1.14829Z"
          fill={getColor(mode)}
        />
      </svg>
    </div>
  );
};

export { DownArrow, UpArrow, RightArrow };
